<ng-container *ngIf="reservation">
  <section>
    <div class="flex flex-col gap-1">
      <div class="text-night-darker font-bold text-sm">Upsells</div>

      @if (loading()) {
        <mat-spinner diameter="24"/>
      } @else {
        @if (upsellOrders().length > 0) {
          <div class="flex flex-col gap-2">
            @if (approvedUpsells().length > 0) {
              <div>
                <div class="text-night-lighter text__small">Purchased:</div>

                <div class="flex flex-col gap-0.5 text-sm text-text-primary">
                  <div *ngFor="let product of approvedUpsells()">
                    @if (product.quantity > 1) {
                    <span class="font-medium">{{ product.quantity }}x</span>
                    }

                    {{ product.name }}

                    @if (product.type && ['early_checkin', 'late_checkout'].includes(product.type) && product.metadata?.hours) {
                    ({{ product.metadata.hours }}h)
                    }
                  </div>
                </div>
              </div>
            }

            @if (pendingUpsellRequests().length > 0) {
              <div>
                <div class="text-night-lighter text__small">Pending requests:</div>

                <div class="flex flex-col gap-0.5 text-sm text-text-primary">
                  <div *ngFor="let product of pendingUpsellRequests()">
                    @if (product.quantity > 1) {
                      <span class="font-medium">{{ product.quantity }}x</span>
                    }

                    {{ product.name }}

                    @if (product.type && ['early_checkin', 'late_checkout'].includes(product.type) && product.metadata?.hours) {
                      ({{ product.metadata.hours }}h)
                    }
                  </div>
                </div>
              </div>
            }

            @if (deniedUpsells().length > 0) {
              <div>
                <div class="text-night-lighter text__small">Denied requests:</div>

                <div class="flex flex-col gap-0.5 text-sm text-text-primary">
                  <div *ngFor="let product of deniedUpsells()">
                    @if (product.quantity > 1) {
                      <span class="font-medium">{{ product.quantity }}x</span>
                    }

                    {{ product.name }}

                    @if (product.type && ['early_checkin', 'late_checkout'].includes(product.type) && product.metadata?.hours) {
                      ({{ product.metadata.hours }}h)
                    }
                  </div>
                </div>
              </div>
            }

            <sbnb-button
              class="block"
              size="mini"
              type="secondary"
              [fullWidth]="true"
              (clicked)="openUpsellsModal()">
              View upsells details
            </sbnb-button>
          </div>
        } @else {
          <div class="text-night-lighter text__small">No upsells purchased yet.</div>
        }
      }
    </div>
  </section>
</ng-container>
